/**
 * -----------------------------------------------------------------------------
 * Popup - Create New Rule
 * -----------------------------------------------------------------------------
 * This popup is used for creating a new rule in the organization.
 */

import { Formik, useFormik } from "formik";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { setModalsData, TListingQueryParams, TModalsState } from "../../../api/store/commonSlice";
import { AdminFormFieldInput, AdminFormFieldSubmit } from "../../../components/admin/formFields";
import { routeUrls } from "../../../navigation/routeUrls";
import { formInitialValues, TFormFieldNames, YupValidationSchema } from "./validation";
import { useCreateOrganizationRuleAlertListMutation } from "../../../api/network/adminApiServices";
import { APP_CONFIG } from "../../../constants/constants";
import { serializeErrorKeyValues } from "../../../api/network/errorCodes";
import FTModal from "../../../components/common/FTModal";
import FormActionButtons from "../../../components/admin/formActionButtons";

const AddNewRule = () => {
  const { t: tMain } = useTranslation();
  const { t } = useTranslation('translation', { keyPrefix: 'manageRuleAlert.create_new' });
  const modalsState = useSelector((state: { commonReducer: { modals: TModalsState } }) => state.commonReducer.modals);
  const listingQueryParams: TListingQueryParams = useSelector((state: any) => state.commonReducer.listingQueryParams);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // user mutation
  const [createOrgRuleAPITrigger] = useCreateOrganizationRuleAlertListMutation();

  const isFetchingOrgRulesPermissions = false;

  const hideModal = () => {
    dispatch(setModalsData({ ...modalsState, showCreateRule: false }));
  };
      const formik = useFormik({
        initialValues:formInitialValues,
        validationSchema:YupValidationSchema,
        onSubmit:(values, { setSubmitting }) => {
          // if(APP_CONFIG.TOASTS.INFO) toast.info(t('loginScreen.toast.logging_you_in'));

          createOrgRuleAPITrigger({
            ruleid: values.ruleid,
          })
            .unwrap()
            .then((data) => {
              if (!!data?.ruleid) {
                dispatch(setModalsData({ ...modalsState, showCreateRule: false }));
                toast.success(t('toast.create_success'), { autoClose: 10000 });
                navigate(`${routeUrls.dashboardChildren.adminChildren.manage_rule_alert}/${data?.ruleid}`, { state: { new: true } });
              } else {
                toast.error(t('toast.create_failed'));
              }
            })
            .catch((error) => {
              const errors = !!error?.data ? serializeErrorKeyValues(error?.data) : [t('toast.create_failed')];
              toast.error(errors?.join(' '));
            })
            .finally(() => {
              setSubmitting(false);
            });
        }
      });
      const{
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        dirty,
        setFieldValue,
      } = formik;
        const invalidFields =
          Object.keys(errors)
            .filter(key => !!errors[key as TFormFieldNames]);
        const isFormValid = invalidFields.length === 0 && dirty;
        const MemoizedFormActionButtons = useMemo(() => {
          return (
            <>
              <FormActionButtons
                buttons={[
                  {
                    label:t('submit_button'),
                    variant:"primary",
                    disabled:!isFormValid || isSubmitting ||  isFetchingOrgRulesPermissions/* || isLoading*/
                  },
                  {
                    label:tMain('cancel'),
                    type:"button",
                    variant:"danger-transparent",
                    disabled:isSubmitting || isFetchingOrgRulesPermissions, /* || isLoading*/
                    onClick:()=>hideModal()
                  },
                ]}
              />
            </>
          );
        }, [
          isFormValid,
          isSubmitting, 
          isFetchingOrgRulesPermissions       
        ])
  return (
    <FTModal
      visible={modalsState.showCreateRule}
      heading={t("heading")}
      onHide={hideModal}
    >
          <form className="grid grid-cols-6 gap-6" onSubmit={handleSubmit}>
            <p className="col-span-6 mt-0 leading-relaxed text-gray-500">
              {t("sub_heading")}
            </p>

            <AdminFormFieldInput
              label={t('ruleid')}
              type="text"
              id="ruleid"
              name="ruleid"
              placeholder={t('ruleid_placeholder')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.ruleid}
              touched={touched.ruleid}
              error={errors.ruleid} />
            {MemoizedFormActionButtons}

            {/* <AdminFormFieldSubmit
              label={t('submit_button')}
              variant="primary"
              disabled={!isFormValid || isSubmitting || isFetchingOrgRulesPermissions}//  || isLoading
            />

            <AdminFormFieldSubmit
              label={tMain('cancel')}
              type="button"
              variant="danger-transparent"
              disabled={isSubmitting || isFetchingOrgRulesPermissions }// || isLoading
              onClick={hideModal}
            /> */}
          </form>
    </FTModal>
  )
};
export default AddNewRule;
